import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import FadeInUp from '../components/FadeInUp';
import SEO from '../components/SEO';

const About = () => {
  const pillars = [
    {
      label: 'Small by design',
      description: 'No junior teams, no account managers, no bloated delivery structures. Every engagement is led personally by a principal consultant.',
    },
    {
      label: 'Senior by default',
      description: '15+ years of hands-on experience across Azure, AWS, GCP, Databricks, Snowflake, and the full modern data stack.',
    },
    {
      label: 'Technology agnostic',
      description: "We recommend the right tool for the job — we're not a vendor partner, and that's intentional.",
    },
  ];

  return (
    <div className="min-h-screen bg-[#0a0a0a] text-white pt-32 pb-20">
      <SEO title="About" description="Data Kitchen is a boutique data consultancy. Senior-led, outcomes-focused, and independent of vendor partnerships. Based in Sydney, Australia." path="/about" />
      <div className="px-8 md:px-16 lg:px-24 max-w-5xl">

        {/* Hero */}
        <FadeInUp>
          <p className="text-xs tracking-[0.3em] uppercase text-silver mb-6">The Origin</p>
        </FadeInUp>

        {/* Founding story */}
        <FadeInUp delay={0.1}>
          <div className="max-w-3xl mb-24 space-y-6 text-lg text-soft-white leading-relaxed">
            <p>
              Data Kitchen was founded by a senior enterprise architect with 15+ years of experience
              designing and implementing data platforms for some of Australia's largest organisations.
            </p>
            <p>
              The opportunity was clear: a consulting model built differently — senior-led, outcomes-focused,
              and grounded in the balance between strategic vision and pragmatic execution.
            </p>
          </div>
        </FadeInUp>

        {/* Philosophy pull quote */}
        <FadeInUp delay={0.1}>
          <div className="border-l-2 border-gray-600 pl-8 mb-24">
            <p className="text-2xl md:text-3xl font-light text-soft-white leading-relaxed">
              "The kitchen analogy isn't just branding — it's philosophy. Great cooking requires
              the finest ingredients, masterful preparation, and impeccable presentation.
              Great data platforms require the same discipline."
            </p>
          </div>
        </FadeInUp>

        {/* Three pillars */}
        <FadeInUp>
          <p className="text-xs tracking-[0.3em] uppercase text-silver mb-12">How we operate</p>
        </FadeInUp>
        <div className="grid md:grid-cols-3 gap-12 mb-24">
          {pillars.map((pillar, i) => (
            <FadeInUp key={pillar.label} delay={i * 0.1}>
              <h3 className="text-xl font-normal mb-3">{pillar.label}</h3>
              <p className="text-silver leading-relaxed text-sm">{pillar.description}</p>
            </FadeInUp>
          ))}
        </div>

        {/* CTA */}
        <FadeInUp>
          <div className="border-t border-outline pt-16 flex flex-col md:flex-row md:items-center md:justify-between gap-8">
            <div>
              <h2 className="text-3xl md:text-4xl font-light mb-3">Ready to work together?</h2>
              <p className="text-silver">Let's explore how we can accelerate your data journey.</p>
            </div>
            <Link to="/contact" className="flex-shrink-0">
              <Button
                variant="outline"
                className="bg-white text-black hover:bg-soft-white border-none px-8 py-6 text-sm tracking-wider uppercase transition-all duration-300"
              >
                Get in Touch
              </Button>
            </Link>
          </div>
        </FadeInUp>

      </div>
    </div>
  );
};

export default About;
